import Box from "@mui/material/Box";
import useSunoDialer from "components/suno-dialer/use-suno-dialer.hook";
import PatientAssignedTags from "features/patients/patient-assigned-tags";

export default function TagsBlock() {
  const { activeCallDetails } = useSunoDialer();

  if (!activeCallDetails?.callerId) return null;
  return (
    <Box sx={{ px: 3, pt: 1, pb: 0 }}>
      <PatientAssignedTags patientId={Number(activeCallDetails?.callerId)} />
    </Box>
  );
}
